module.exports = __webpack_public_path__ + "static/Rectangle217Md-d9b01ee04501e092efd72324c5b80b24.png";